// extracted by mini-css-extract-plugin
export default {"markdownHeroContainer":"Readme-module__markdownHeroContainer--RdLC8","markdownHeroLogo":"Readme-module__markdownHeroLogo--X2PYr"};